/**
 * משכי אנימציה ו־easing משותפים לתפריט התבניות (Fade, Collapse, stagger לשורות).
 */

export const TEMPLATES_MENU_DURATION = {
  /** Fade לתוכן מורחב / מצב ריק */
  fadeSlow: 400,
  /** Fade קצר (למשל טעינה) */
  fade: 280,
  /** פתיחת Collapse של תבנית נבחרת */
  collapseEnter: 360,
  /** סגירת Collapse */
  collapseExit: 220,
} as const;

/** תואם ease-out חלק (למשל `[0.22, 1, 0.36, 1]`) לשימוש ב־CSS animation */
export const TEMPLATES_MENU_EASING_CSS = 'cubic-bezier(0.22, 1, 0.36, 1)';

const STAGGER_MS = 50;
const STAGGER_CAP_MS = 400;

/** עיכוב כניסה לפי אינדקס שורה — stagger מוגבל כדי לא להאריך רשימות ארוכות */
export function templatesMenuListRowDelayMs(listIndex: number): number {
  return Math.min(listIndex * STAGGER_MS, STAGGER_CAP_MS);
}
